import { Action } from 'redux';
//import States
import {
    AdministratorState,
    AppState,
    getInitialMinCostPerSquareFootVersionsState,
    MinCostPerSquareFootVersionsState
} from '@app/redux/states';
// import Actions
import {
    LoadMinCostPerSquareFootVersionsAction,
    SelectMinCostPerSquareFootVersionAction,
} from '@app/redux/actions';
// import api models
import {
    MinCostPerSquareFootVersionResponse
} from '@app/models/api';
// import state initializers
import {
    initializeAdministratorState
} from '@app/redux/reducers/initializers';
import {
    queryAdministratorState
} from '@app/redux/reducers/queries';

/**
 * This handles initializing the state.
 * @param state
 */
const initializeState = (state: AppState): AppState => {
    let newState: AppState = { ...state };
    newState = initializeAdministratorState(newState);
    const administratorState: AdministratorState = queryAdministratorState(newState);

    if (administratorState.minCostPerSquareFootVersionsState === undefined) {
        administratorState.minCostPerSquareFootVersionsState = getInitialMinCostPerSquareFootVersionsState();
    }
    else {
        administratorState.minCostPerSquareFootVersionsState = { ...administratorState.minCostPerSquareFootVersionsState };
    }
    return newState;
};

/**
 * Query the state
 * @param state
 */
const queryMinCostPerSquareFootVersionsState = (state: AppState): MinCostPerSquareFootVersionsState => {
    return queryAdministratorState(state).minCostPerSquareFootVersionsState;
};

//#region Load Min Cost Per Square Foot Version

const LoadMinCostPerSquareFootVersionReducer = (state: AppState, action: Action): AppState => {
    const loadMinCostPerSquareFootVersionAction: LoadMinCostPerSquareFootVersionsAction = action as LoadMinCostPerSquareFootVersionsAction;
    const minCostPerSquareFootVersions: MinCostPerSquareFootVersionResponse[] = loadMinCostPerSquareFootVersionAction.minCostPerSquareFootVersions;

    const newState: AppState = initializeState(state);
    const minCostPerSquareFootVersionsState: MinCostPerSquareFootVersionsState = queryMinCostPerSquareFootVersionsState(newState);

    minCostPerSquareFootVersionsState.minCostPerSquareFootVersions = minCostPerSquareFootVersions;
    minCostPerSquareFootVersionsState.areMinCostPerSquareFootVersionsLoaded = true;

    return newState;
};

//#endregion Load Min Cost Per Square Foot Version

//#region Select Min Cost Per Square Foot Version

const SelectMinCostPerSquareFootVersionReducer = (state: AppState, action: Action): AppState => {
    const selectMinCostPerSquareFootVersionAction: SelectMinCostPerSquareFootVersionAction = action as SelectMinCostPerSquareFootVersionAction;
    const versionId: number = selectMinCostPerSquareFootVersionAction.versionId;

    const newState: AppState = initializeState(state);
    const minCostPerSquareFootVersionsState: MinCostPerSquareFootVersionsState = queryMinCostPerSquareFootVersionsState(newState);

    minCostPerSquareFootVersionsState.selectedMinCostPerSquareFootVersionId = versionId;

    return newState;
};

//#endregion Select Min Cost Per Square Foot Version

//#region Select Min Cost Per Square Foot Version

const UnselectMinCostPerSquareFootVersionReducer = (state: AppState, action: Action): AppState => {
    const newState: AppState = initializeState(state);
    const minCostPerSquareFootVersionsState: MinCostPerSquareFootVersionsState = queryMinCostPerSquareFootVersionsState(newState);

    minCostPerSquareFootVersionsState.selectedMinCostPerSquareFootVersionId = undefined;

    return newState;
};

//#endregion Select Min Cost Per Square Foot Version

//#region export reducers

export {
    LoadMinCostPerSquareFootVersionReducer,
    SelectMinCostPerSquareFootVersionReducer,
    UnselectMinCostPerSquareFootVersionReducer,
};

//#endregion export reducers

//#region export queries

export {
    queryMinCostPerSquareFootVersionsState,
};

//#endregion export queries

//#region export initializer

export {
    initializeState
};

//#endregion export initializer
